module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_6.91b8a569.png";